<template>
  <div id="included-services">
    <h2 class="form-head mb-2 pt-sm-4">Included Services</h2>
    <p class="text-center">Below is a list of services included in our {{ selectedCategoryName }}.</p>

    <div class="carousel-container">
      <carousel :navigationEnabled="true" :paginationEnabled="true" :autoplay="false" :spacePadding="0"
      :perPageCustom="[[0, 1], [653, 2], [1024, 2]]" :paginationPadding="3" class="mx-auto">
        <slide v-for="(serviceGroup, serviceGroupKey) in services" :key="serviceGroupKey">
          <div class="card services-card">
            <div class="services-card-header">
              <h4>{{ serviceGroup.name }}</h4>
            </div>
            <div class="services-card-body">
              <ul class="list-unstyled">
                <li v-for="service in serviceGroup.services.filter(service => service.category_key === categoryKey)"><i class="fa light fa-check"></i> <span>{{ service.name
                    }}</span></li>
              </ul>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    selectedCategoryName: {
      type: String
    },
    categoryKey: {
      type: String
    },
    services: {
      type: Array,
      required: true
    },
  },
  computed: {
  }
}

</script>

<style lang="css" scoped>
#included-services {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carousel-container {
  width: 100%; 
}

.carousel .slide {
  display: flex;
  justify-content: center;
}

.services-card {
  border: solid 1px #44A0ED;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 10px;
  height: 90%;
}

.services-card-header {
  padding: 25px 15px 5px;
}

.services-card-header>h4 {
  font-size: 14px;
  font-weight: 600;
}

.services-card-body {
  font-size: 12px;
  padding: 0px 15px 25px;
}

.services-card-body>ul>li>i {
  margin-right: 10px;
}
</style>
